import React, { useRef, useEffect, useState, ComponentProps } from "react";
import { useField } from "@unform/core";

import * as S from "./styles";

interface InputProps extends ComponentProps<any> {
  name: string;
  type?: string;
  className?: string;
  label?: string;
  labelStyle?: Record<string, any>;
  inputStyle?: Record<string, any>;
  containerStyle?: Record<string, any>;
  required?: boolean;
  isLoading?: boolean;
}

type Props = InputProps;

const formatWeight = (value: number) => {
  return (value / 1000).toLocaleString("pt-BR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
};

export const InputWeight: React.FC<Props> = ({
  name,
  label,
  type = "text",
  className = "field-container",
  labelStyle = {},
  inputStyle = {},
  containerStyle = {},
  required = false,
  isLoading = false,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);
  // Inicializa o valor em gramas com base no valor padrão (em kg).
  const [value, setValue] = useState<number>(
    defaultValue ? Number(defaultValue) * 1000 : 0
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value.replace(/[^\d]/g, "");
    const numericValue = Number(rawValue);
    setValue(numericValue);
	if (rest.onChange) {
		rest.onChange(numericValue);
	}
   
  };

  const Label = () => (
    <S.FieldLabel htmlFor={fieldName} style={labelStyle}>
      {label}
      {required && <span>*</span>}
    </S.FieldLabel>
  );

  const Error = () => <S.FieldError>{error}</S.FieldError>;

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: () => value / 1000, // Armazena o valor em kg
      setValue: (_, newValue) => setValue(Number(newValue *1000)),
      clearValue: () => setValue(0),
    });
  }, [fieldName, registerField, value]);

  return (
    <S.FieldContainer style={containerStyle} className={className}>
      {label && <Label />}
      <S.Input
        {...rest}
        ref={inputRef}
        type={type}
        id={fieldName}
        name={fieldName}
        value={formatWeight(value)}
        onChange={handleChange}
        style={inputStyle}
      />
      {isLoading && <S.IsLoading />}
      {error && <Error />}
    </S.FieldContainer>
  );
};
